export enum ButtonVariantEnum {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    QUATERNARY = 'quaternary',
    QUINARY = 'quinary',
    SENARY = 'senary',
    DANGER = 'danger',
}
